// License-code storage. The license gate writes the validated code
// here on success; signup pulls it back out and sends it as the
// `license_code` field. Once signup succeeds the code is permanently
// consumed on the server, so we keep the local copy too — the gate
// trusts the local value as proof the user already passed it once,
// and a signed-in user has nothing left to prove since their account
// is permanently linked to the (now redeemed) code.

const STORAGE_KEY = "coscience.license";

function read(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function write(code: string | null): void {
  try {
    if (code === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // localStorage unavailable; gate will re-prompt every reload.
  }
}

export const licenseStore = {
  get: read,
  set: write,
};
